<pt-details-layout
  [infoMessage]="infoMessage"
  [noDataMessage]="noDataMessage"
  [showInfo]="showInfo"
  [showNoData]="showNoData"
  [showWarning]="showWarning"
  [title]="title"
  [warningMessage]="warningMessage">
  <ng-container body *ngIf="!showNoData">
    <div (click)="openDetails(item)" *ngFor="let item of entities" class="dcard-container">
      <pt-entity-icon [entity]='entity' [width]='30' style="margin-right: 10px"></pt-entity-icon>
      <div class="details-link">{{ item.name }}</div>
    </div>
  </ng-container>
</pt-details-layout>
